// extracted by mini-css-extract-plugin
export default {"arrow_btns":"RankingSubSection_arrow_btns__3nECJ"};